import styles from './WidgetStyles.module.css';
import type { ExampleQuestionCategory } from '../types/exampleQuestions';
import { ChevronIcon } from './WidgetIcons';

export type ExamplePromptsPanelProps = {
    heading: string;
    categories: ExampleQuestionCategory[];
    onQuestionSelected?: (question: string) => void;
};

export function ExamplePromptsPanel({
    heading,
    categories,
    onQuestionSelected
}: ExamplePromptsPanelProps) {
    if (categories.length === 0) {
        return null;
    }

    return (
        <section className={styles.examplePromptsPanel} aria-live="polite">
            <p className={styles.examplePromptsHeading}>{heading}</p>
            <div className={styles.examplePromptsAccordion}>
                {categories.map((category) => (
                    <details className={styles.examplePromptsItem} key={category.title}>
                        <summary>
                            <span className={styles.examplePromptsSummaryText}>{category.title}</span>
                            <span className={styles.examplePromptsChevron} aria-hidden="true">
                                <ChevronIcon />
                            </span>
                        </summary>
                        <ul>
                            {category.questions.map((question, index) => (
                                <li key={`${category.title}-${index}`}>
                                    <button
                                        className={styles.examplePromptsQuestionButton}
                                        type="button"
                                        onClick={() => onQuestionSelected?.(question)}
                                    >
                                        {question}
                                    </button>
                                </li>
                            ))}
                        </ul>
                    </details>
                ))}
            </div>
        </section>
    );
}
